import { gql } from '@apollo/client';

export const GET_BOOKSETID = gql`
  query SkWeb_Booksets_5($bookId: ID!) {
    book(bookId: $bookId) {
      _bookset
    }
  }
`;
